export const PRODUCTION_STEPS_COL_WIDTHS = [
  640,
  100,
  116,
  116,
  129,
  124,
  100,
  120,
  130,
  170,
  160,
  177,
  177,
  150,
  40 // delete button
]

// export const PRODUCTION_STEPS_FIST_COL_PL = 80
const SECTION_FIRST_COL_PL = 80
const STEP_FIRST_COL_PL_DIFF = 32
const STEP_COMPONENT_FIRST_COL_PL_DIFF = 60

export const PRODUCTION_STEPS_SPACINGS = {
  ACCORDION_EXPANDED_ICON_LEFT: 48,
  SECTION_FIRST_COL_PL,
  STEP_FIRST_COL_PL_DIFF,
  STEP_FIRST_COL_PL: SECTION_FIRST_COL_PL + STEP_FIRST_COL_PL_DIFF, // 112
  STEP_COMPONENT_FIRST_COL_PL_DIFF
}

export const BUTTON_STATUS = {
  DISABLED: 0,
  ENABLED: 1,
  SAVE_ONLY: -1
}


export const COLS_OFFSETS = { // offsets from const PRODUCTION_STEPS_SPACINGS.STEP_FIRST_COL_PL
  stepComponents: 20,
  priorStepComponents: 38
}

export const ACCORDION_ICONS_OFFSETS = {
  section: 48,
  productionSteps: 80,
  stepComponents: 100
}

export const DEFAULT_ROW_PER_PAGE_OPTIONS = [5, 10, 25, 50, 100]
export const DEFAULT_FILTERS = { page: 0, rowsPerPage: 25 }

export const EDITION_PAGE_INITIAL_ACTIONS = { hasDeleted: false, hasEdited: false, hasAdded: false }

export const ALPHABETS = [
  "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M",
  "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
]

export const STOPWORDS = [
  // Prépositions
  "à",
  "de",
  "du",
  "en",
  "au",
  "aux",
  "pour",
  "par",
  "avec",
  "sans",
  "chez",
  "sous",
  "sur",
  "vers",
  "dans",
  "entre",
  "pendant",
  "jusque",
  "jusqu",
  "au-dessus de",
  "au-dessous de",
  "près de",
  "loin de",
  "autour de",
  "au milieu de",

  // Articles définis
  "le",
  "la",
  "les",

  // Articles indéfinis
  "un",
  "une",
  "des",

  // Pronoms personnels sujets
  "je",
  "tu",
  "il",
  "elle",
  "nous",
  "vous",
  "ils",
  "elles",

  // Pronoms personnels compléments
  "me",
  "te",
  "le",
  "la",
  "lui",
  "nous",
  "vous",
  "les",
  "leur",

  // Pronoms possessifs
  "mon",
  "ma",
  "mes",
  "ton",
  "ta",
  "tes",
  "son",
  "sa",
  "ses",
  "notre",
  "nos",
  "votre",
  "vos",
  "leur",
  "leurs",

  // Pronoms démonstratifs
  "ce",
  "cette",
  "ces",

  // Pronoms interrogatifs
  "quel",
  "quelle",
  "quels",
  "quelles",

  // Pronoms relatifs
  "qui",
  "que",
  "quoi",
  "dont",
  "où",

  // Pronoms indéfinis
  "rien",
  "chacun",
  "tout",
  "tous",
  "toutes",

  // contractés
  "l",
  "d",
  "s",
  "c",
  "j",

  // conjonctions
  "&",
  "et"
]

export const SUPPLIER_ITEM_DATAGRID_STORAGE = "st_supplierItemDatagrid"
export const SUPPLIER_DATAGRID_STORAGE = "st_supplierDatagrid"
export const RECIPE_DATAGRID_STORAGE = "st_recipeDatagrid"
export const REUSABLE_STEP_DATAGRID_STORAGE = "st_reusableStepDatagrid"
export const PRODUCTION_STEP_EXECUTION_FILTER_STORAGE = "st_productionStepExecutionStorage"
export const PRODUCTION_STEP_EXECUTION_DATAGRID_STORAGE = "st_productionStepExecutionDatagrid"
export const PROD_PLANNER_FILTER_DATE = "prodPlanner_filter_date"

/**
 * @param {string} path - The path of the route to check and cached (not the full URL, just the beginning part)
 * @param {string[]} storage - The storage keys to be used to store the datagrid state
 ** e.g: We have 3 routes: "/pse/consultation", "/pse/filter", "/pse/some_id"
 ** "/pse/consultation" is the page where we want to filter data
 ** from "/pse/some_id" to "/pse/consultation" : keep the filter
 ** from "/pse/filter" to "/pse/consultation" : clear the filter => so pathExcludes is ["/filter"]
 * @param {string[]} [pathExcludes] - Optional array of paths to exclude from the storage reset
 */
export const STORAGE_GRID_ROUTES = [
  { path: "/suppliers", storage: [SUPPLIER_ITEM_DATAGRID_STORAGE, SUPPLIER_DATAGRID_STORAGE] },
  { path: "/products", storage: [RECIPE_DATAGRID_STORAGE] },
  { path: "/resources/reusableSteps", storage: [REUSABLE_STEP_DATAGRID_STORAGE] },
  { path: "/productionStepExecutions", storage: [PRODUCTION_STEP_EXECUTION_DATAGRID_STORAGE], pathExcludes: ["/filter"] },
]

// -------- PROD PLANNER CONSTANTS --------
// Height (in pixels) of one time block in the planner (e.g., 25px for each 15-minute slot)
export const BLOCK_HEIGHT = 25
// Duration (in minutes) represented by a single block
export const BLOCK_TIME = 15
// Starting hour of the schedule (e.g., 6:00 AM)
export const START_HOUR = 6
// Ending hour of the schedule (e.g., 2:00 PM)
export const END_HOUR = 17
// Total duration of the planner in minutes
export const TOTAL_MINUTES = (END_HOUR - START_HOUR) * 60
// Total number of time blocks (e.g., 8 hours * 4 blocks/hour = 32) + 1 to include the last hour block
export const TOTAL_BLOCKS = TOTAL_MINUTES / BLOCK_TIME + 1
// Height (in pixels) of the header block that displays the machine name
export const HEADER_BLOCK_HEIGHT = 96
// Starting block index for the day (0 corresponds to START_HOUR)
export const DAY_START_BLOCK = 0
// Ending block index for the day (e.g., 44 blocks for an 11-hour day with 15-minute intervals)
export const DAY_END_BLOCK = (END_HOUR - START_HOUR) * (60 / BLOCK_TIME)

// Unassigned panel width (in pixels) - used for consistent sizing
export const UNASSIGNED_PANEL_WIDTH = 342
// Unassigned tile content width (panel width minus padding)
export const UNASSIGNED_TILE_CONTENT_WIDTH = UNASSIGNED_PANEL_WIDTH - 32 // 342 - 32 (16px padding on each side)

// -------- PSE SIDEBAR MENUS CONSTANTS --------
export const PSES_SIDEBAR_MENUS_ENUM = {
	UNPACKING: "unpacking",
	COOKING: "cooking",
	WEIGHING: "weighing",
	TASTING: "tasting"
}

export const PSES_STATUS_TABS = {
	TODO: "TODO",
	IN_PROGRESS: "IN_PROGRESS",
	DONE: "DONE",
	LOCKED: "LOCKED",
}

export const DEFAULT_PSES_STATUS_TAB = PSES_STATUS_TABS.TODO
export const SIDEBARS_WIDTH_STATUS_TABS = [PSES_SIDEBAR_MENUS_ENUM.COOKING, PSES_SIDEBAR_MENUS_ENUM.WEIGHING, PSES_SIDEBAR_MENUS_ENUM.TASTING]
export const DEFAULT_SELECTED_PSES_SIDEBAR_MENU = PSES_SIDEBAR_MENUS_ENUM.COOKING
